import { secondsToTimeInput } from '@/utils/time';

/**
 * Filtr czasu
 *
 * @export
 * @param {number} seconds
 * @returns
 */
export function time(seconds: number) {
  const timeInput = secondsToTimeInput(seconds) as any;

  Object.keys(timeInput).map(key => {
    timeInput[key] = timeInput[key] < 10 ? `0${timeInput[key]}` : timeInput[key];
  });

  return `${timeInput.hour}:${timeInput.minute}:${timeInput.second}:${timeInput.hundredth}`;
}
